import React from 'react';
import { Alert, Container } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    // Optionnel: envoyer à un service de logging externe
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container className="mt-5">
          <Alert variant="danger">
            <Alert.Heading>Oups! Une erreur est survenue</Alert.Heading>
            <p>
              {process.env.NODE_ENV === 'development'
                ? this.state.error?.toString()
                : "Une erreur inattendue s'est produite."}
            </p>
            <button
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Recharger la page
            </button>
          </Alert>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;


